import Button from "../core/Button";
import Strings from "../core/data/Strings";
import ResizableContainer from "../core/ResizableContainer";
import ResizableScene from "../core/ResizableScene";
import GameColors from "../GameColors";
import Fonts from "../utils/Fonts";
import Overlay from "../utils/Overlay";
import TweenUtils from "../utils/TweenUtils";
import Recap from "./Recap";

export default class QuitPopup extends ResizableContainer {
	recap: Recap;
	buttons: Button[];
	constructor(scene: ResizableScene, recap?: Recap) {
		super(scene, 0, 0);
		this.recap = recap;

		const overlay = Overlay.create(scene, 0.8);
		overlay.tint = 0x3a2454;

		const popupGroup = scene.add.container();
		const bg = scene.add.image(0, 0, "quitBacker");
		this.add([overlay, popupGroup]);

		const textStyle = {
			fontFamily: Fonts.LunchBoxRegular,
			fontSize: "40px",
			color: GameColors.WHITE,
			align: "center",
		}
		const header = scene.add.text(0, 0, Strings.get("ReturnToMenus"), textStyle);
		//textStyle.fontSize = "56px";
		//const description = scene.add.text(0, 0, Strings.get("LoseProgress"), textStyle);
		popupGroup.add([bg, header]);

		//textStyle.fontSize = "48px";

		const corkBacker = scene.add.image(0, 0, "quitCorkBacker");
		popupGroup.add(corkBacker);

		const yesContainer = scene.add.container();
		const yesButton = scene.add.button(0, 0, "yesBtn", 0, this.confirm, this, true);
		yesContainer.add([yesButton]);
		yesContainer.setSize(yesButton.width, yesButton.height);

		const noContainer = scene.add.container();
		const noButton = scene.add.button(0, 0, "noBtn", 0, this.cancel, this, true);
		noContainer.add([noButton]);
		noContainer.setSize(noButton.width, noButton.height);

		this.buttons = [yesButton, noButton];

		popupGroup.add([noContainer, yesContainer]);

		this.addResize(() => {
			overlay.resize();
			scene.alignIn.Center(popupGroup, scene.viewport, 0, 28);
			scene.alignIn.TopCenter(header, bg, 0, -55);
			//scene.alignTo.BottomCenter(description, header, 0, 30);
			scene.alignIn.BottomCenter(corkBacker, bg, 0, -50);
			scene.alignIn.RightCenter(noContainer, corkBacker, -15, 3);
			scene.alignTo.LeftCenter(yesContainer, noContainer, 15, 0);
		});
	}

	protected confirm(): void {
		// this.scene.soundManager.play("click");
		for (const button of this.buttons) button.disableInteractive();
		if (this.recap) {
			this.setAlpha(0);
			this.recap.tweenOut(() => this.scene.scene.start("PreloaderScene", { destinationScene: "PhotoSelectScene" }));
		}
		else this.scene.scene.start("PreloaderScene", { destinationScene: "PhotoSelectScene" });
	}

	protected cancel(): void {
		this.scene.soundManager.play("click");
		for (const button of this.buttons) button.disableInteractive();
		this.destroy();
	}
}